<div class="border-box-darkgrey p-xl-4">
  <div class="row">
    <div class="col">
      <h5>Os meus dados de faturação</h5>
    </div>
    <div class="col-auto">
      <button type="button" (click)="showDataToggle()" class="btn-black">{{textButton}}</button>
    </div>
  </div>
  <hr>
  <div *ngIf="showData">
    <div class="lead"><strong>Novos dados de faturação</strong></div>
    <form [formGroup]="dataform" (ngSubmit)="saveEvent()" class="mt-3">
      <div class="row">
        <div class="col-sm-6 col-xl-3 mb-3">
          <label for="BillingType">Tipo de faturação</label>
          <input formControlName="BillingType" type="text" class="form-control" id="BillingType" placeholder="Tipo de faturação" [ngClass]="{'is-invalid':dataform.get('BillingType').invalid && (!dataform.get('BillingType').pristine || submitted == 1) , 'is-valid':dataform.get('BillingType').valid && !dataform.get('BillingType').pristine}">
          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['BillingType'].errors || !dataform.controls['BillingType'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['BillingType'].errors || !dataform.controls['BillingType'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-3 mb-3">
          <label for="Tradename">Nome comercial</label>
          <input formControlName="Tradename" type="text" class="form-control" id="Tradename" placeholder="Nome comercial" [ngClass]="{'is-invalid':dataform.get('Tradename').invalid && (!dataform.get('Tradename').pristine || submitted == 1) , 'is-valid':dataform.get('Tradename').valid && !dataform.get('Tradename').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Tradename'].errors || !dataform.controls['Tradename'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Tradename'].errors || !dataform.controls['Tradename'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-3 mb-3">
          <label for="Cif">NIF</label>
          <input formControlName="Cif" type="text" class="form-control" id="Cif" placeholder="NIF" [ngClass]="{'is-invalid':dataform.get('Cif').invalid && (!dataform.get('Cif').pristine || submitted == 1) , 'is-valid':dataform.get('Cif').valid && !dataform.get('Cif').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Cif'].errors || !dataform.controls['Cif'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Cif'].errors || !dataform.controls['Cif'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-3 mb-3">
          <label for="PrincipalContact">Contacto principal</label>
          <input formControlName="PrincipalContact" type="text" class="form-control" id="PrincipalContact" placeholder="Contacto principal" [ngClass]="{'is-invalid':dataform.get('PrincipalContact').invalid && (!dataform.get('PrincipalContact').pristine || submitted == 1) , 'is-valid':dataform.get('PrincipalContact').valid && !dataform.get('PrincipalContact').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['PrincipalContact'].errors || !dataform.controls['PrincipalContact'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['PrincipalContact'].errors || !dataform.controls['PrincipalContact'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-4 mb-3">
          <label for="Address">Morada</label>
          <input formControlName="Address" type="text" class="form-control" id="Address" placeholder="Morada" [ngClass]="{'is-invalid':dataform.get('Address').invalid && (!dataform.get('Address').pristine || submitted == 1) , 'is-valid':dataform.get('Address').valid && !dataform.get('Address').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Address'].errors || !dataform.controls['PrincipalContact'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Address'].errors || !dataform.controls['Address'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-4 mb-3">
          <label for="Phone">Telefone</label>
          <input formControlName="Phone" type="text" class="form-control" id="Phone" placeholder="Telefone" [ngClass]="{'is-invalid':dataform.get('Phone').invalid && (!dataform.get('Phone').pristine || submitted == 1) , 'is-valid':dataform.get('Phone').valid && !dataform.get('Phone').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Phone'].errors || !dataform.controls['Phone'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Phone'].errors || !dataform.controls['Phone'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-4 mb-3">
          <label for="Mail">E-mail</label>
          <input formControlName="Mail" type="text" class="form-control" id="Mail" placeholder="E-mail" [ngClass]="{'is-invalid':dataform.get('Mail').invalid && (!dataform.get('Mail').pristine || submitted == 1) , 'is-valid':dataform.get('Mail').valid && !dataform.get('Mail').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Mail'].errors || !dataform.controls['Mail'].errors['required']">
              Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Mail'].errors || !dataform.controls['Mail'].errors['maxlength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
      </div>

      <div class="pt-3 pb-3">
        <div class="d-flex justify-content-end">
          <button type="submit" class="btn-orange"> GUARDAR</button>
        </div>
      </div>
    </form>
    <hr>
  </div>

  <div class="table-responsive-sm">
    <table id="tblEvaluation" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table data-tables dataTable condensed-table no-footer w-100">
      <thead>
        <tr>
          <th class="w-10">Tipo de faturação</th>
          <th>Nome comercial</th>
          <th class="w-10">NIF</th>
          <th>Contacto</th>
          <th class="w-16">Morada</th>
          <th class="w-8">Telefone</th>
          <th class="w-16">E-mail</th>
          <th class="w-6">Opções</th>
        </tr>
      </thead>
    </table>
  </div>
</div>